import React, { useEffect, useState, useRef } from "react";
import Layout from "../components/Layout/HomeLayout";
import "../Style/CategoryListPage/Category.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Style/LandingPage/Explore.css";
import SiteReviews from "../components/SiteReviews";

// ✅ Import local static banner images (same as CustomiseTrip)
import banner1 from "../images/customisebanner1.jpg";
import banner2 from "../images/customisebanner2.jpg";
import banner3 from "../images/customisebanner3.jpg";
import banner4 from "../images/customisebanner4.jpg";
const DestinationCard = ({
  name,
  image,
  packageCount = 0,
  startingPrice = 0,
  overview,
}) => {
  return (
    <div className="explore__feature destination-slide-card">
      <Link to={`/category/${encodeURIComponent(name)}`} className="card-link">
        <div className="card-image-wrapper">
          <img src={image} alt={name} />
        </div>
        <div className="card-details">
          <h3 className="trip-title">{name}</h3>
          <p
            className="package-text"
            style={{
              margin: "8px 0",
              padding: "6px 12px",
              borderRadius: "12px",
              backgroundColor: "#ff4d4d",
              color: "white",
              fontWeight: "500",
              display: "inline-block",
            }}
          >
            {packageCount}+ Packages
          </p>
          <p className="trip-overview">
            {overview ||
              "Explore the beauty, culture, and adventure this destination has to offer."}
          </p>
          <p
            className="price-text"
            style={{
              backgroundColor: "#ffca00",
              padding: "10px 20px",
              borderRadius: "12px",
              color: "black",
            }}
          >
            Starting Price: ₹{startingPrice.toLocaleString()}
          </p>
        </div>
      </Link>
    </div>
  );
};

// Slider + Mobile scroll wrapper
const DestinationSlider = ({ destinations }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const mobileRef = useRef(null);

  // Track window width
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Auto scroll for mobile (optional)
  useEffect(() => {
    if (windowWidth > 768) return;
    const slider = mobileRef.current;
    if (!slider) return;
    let scrollAmount = 0;
    const interval = setInterval(() => {
      if (!slider.firstChild) return;
      const cardWidth = slider.firstChild.offsetWidth + 16; // card width + gap
      scrollAmount += cardWidth;
      if (scrollAmount >= slider.scrollWidth) scrollAmount = 0;
      slider.scrollTo({ left: scrollAmount, behavior: "smooth" });
    }, 3000);
    return () => clearInterval(interval);
  }, [windowWidth, destinations]);

  if (windowWidth <= 768) {
    // Mobile: use horizontal scroll like explore.js
    return (
      <div
        ref={mobileRef}
        className="explore__container mobile-slider"
      >
        {destinations.map((dest, idx) => (
          <DestinationCard key={idx} {...dest} />
        ))}
      </div>
    );
  }

  // Desktop/Laptop: use react-slick slider
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    pauseOnHover: true,
    swipe: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="destinations-slider-wrapper">
      <Slider {...settings}>
        {destinations.map((dest, idx) => (
          <DestinationCard key={idx} {...dest} />
        ))}
      </Slider>
      <style>{`
        .destinations-slider-wrapper .slick-slide {
          padding: 15px;
          display: flex !important;
          justify-content: center;
        }
        .destinations-slider-wrapper .destination-slide-card {
          width: 280px;
          max-width: 100%;
          transition: transform 0.3s ease;
        }
        .destinations-slider-wrapper .destination-slide-card img {
          width: 100%;
          height: 350px;
          object-fit: cover;
          border-radius: 12px;
        }
        @media (max-width: 992px) {
          .destinations-slider-wrapper .destination-slide-card { width: 240px; }
        }
        @media (max-width: 768px) {
          .destinations-slider-wrapper .destination-slide-card { width: 90%; }
        }
      `}</style>
    </div>
  );
};

const Destinations = () => {
  const [allCategories, setAllCategories] = useState([]);
  const [allTrips, setAllTrips] = useState([]);
  const [trending, setTrending] = useState([]);
  const [domestic, setDomestic] = useState([]);
  const [international, setInternational] = useState([]);
  const [mountains, setMountains] = useState([]);
  const [beaches, setBeaches] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [catRes, tripRes] = await Promise.all([
          axios.get("/api/category/get-all-category"),
          axios.get("/api/trips/get-all-trips"),
        ]);
        setAllCategories(catRes.data.data || []);
        setAllTrips(tripRes.data.data || []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!allCategories.length || !allTrips.length) return;

    const prepareDestinations = (names) =>
      names.map((name) => {
        const category = allCategories.find(
          (c) => c.name.toLowerCase() === name.toLowerCase()
        );
        const trips = allTrips.filter((t) =>
          t.category?.some((cat) => cat.toLowerCase() === name.toLowerCase())
        );

        let lowestPrice = Infinity;
        trips.forEach((trip) => {
          trip.costing
            ?.filter((c) =>
              c.heading?.toLowerCase().includes("group departure")
            )
            ?.forEach((block) =>
              block.package?.forEach((pkg) => {
                const price = Number(pkg.price);
                if (!isNaN(price) && price > 0 && price < lowestPrice)
                  lowestPrice = price;
              })
            );
        });

        const overview =
          trips[0]?.shortDescription ||
          trips[0]?.overview ||
          category?.overview ||
          "Explore the beauty, culture, and adventure this destination has to offer.";

        return {
          name,
          image: category?.url || "/images/default.jpg",
          packageCount: trips.length,
          startingPrice: isFinite(lowestPrice) ? lowestPrice : 0,
          overview,
        };
      });

    setTrending(
      prepareDestinations([
        "Bali",
        "Thailand",
        "Maldives",
        "Kerala",
        "Spiti Valley",
        "Leh Ladakh",
        "Vietnam",
        "Georgia",
      ])
    );
    setDomestic(
      prepareDestinations(["Kerala", "Himachal Pradesh", "Kashmir", "Rajasthan","Uttarakhand","Spiti Valley","Leh Ladakh","Kargil","Lakshadweep","Sikkim","Andaman and Nicobar","Goa","Karnataka","Meghalaya","Lahaul"])
    );
    setInternational(
      prepareDestinations(["Bali", "Thailand", "Maldives", "Vietnam", "Georgia", "Dubai","Nepal","Sri Lanka","Turkey","Oman","Kenya","Kazakhstan","Azerbaijan","Bhutan","Philippines","Tanzania","Ibiza","Iceland"])
    );
    setMountains(
      prepareDestinations(["Spiti Valley", "Himachal Pradesh", "Kerala","Nepal" ,"Leh Ladakh","Kashmir","Uttarakhand","Bhutan","Kargil","Sikkim","Meghalaya","Oman","Georgia","Meghalaya","Lahaul","Kazakhstan","Azerbaijan"])
    );
    setBeaches(prepareDestinations(["Bali", "Thailand", "Maldives", "Kerala","Goa","Tanzania","Ibiza","Philippines","Kenya","Sri Lanka","Lakshadweep","Andaman and Nicobar","Karnataka","Kerala","Oman","Dubai"]));
  }, [allCategories, allTrips]);
  const bannerImages = [banner1, banner2, banner3, banner4];

  return (
    <Layout>
        <div className="destinations-page category-page">
        {/* ===== Banner Section (same layout as CustomiseTrip) ===== */}
        <div className="category-banner container-fluid">
          <div className="banner-grid">
            {/* LEFT SIDE */}
            <div className="banner-left">
              <div className="banner-left-top">
                <img src={bannerImages[0]} alt="banner1" className="banner-img small" />
                <img src={bannerImages[1]} alt="banner2" className="banner-img small" />
              </div>
              <div className="banner-left-bottom">
                <img src={bannerImages[2]} alt="banner3" className="banner-img large" />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="banner-right">
              <img src={bannerImages[3]} alt="banner4" className="banner-img big" />
              <div className="banner-reviews">
                <SiteReviews variant="slider" hideHeading={true} limit={5} />
              </div>
            </div>
          </div>
        </div>

        <section className="py-5 container">
          <h2 className="fw-bold mb-4 text-center">Trending Destinations</h2>
          <DestinationSlider destinations={trending} />
        </section>

        <section className="py-5 bg-light container">
          <h2 className="fw-bold mb-4 text-center">Domestic Destinations</h2>
          <DestinationSlider destinations={domestic} />
        </section>

        <section className="py-5 container">
          <h2 className="fw-bold mb-4 text-center">International Destinations</h2>
          <DestinationSlider destinations={international} />
        </section>

        <section className="py-5 bg-light container">
          <h2 className="fw-bold mb-4 text-center">Mountain Escapes</h2>
          <DestinationSlider destinations={mountains} />
        </section>

        <section className="py-5 container">
          <h2 className="fw-bold mb-4 text-center">Beaches & Islands</h2>
          <DestinationSlider destinations={beaches} />
        </section>
      </div>
    </Layout>
  );
};

export default Destinations;
